
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import isCallable$1 from './is-callable.js';
import tryToString$1 from './try-to-string.js';

var isCallable = isCallable$1;
var tryToString = tryToString$1;

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};

export { aCallable as default };
//# sourceMappingURL=a-callable.js.map
